import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { deleteAllCookies, getCookie, setCookie } from '../../data/utils/cookie-utils';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { inject } from '@angular/core';
import { sessionTimeout } from '../../data/utils/session-utils';

 
const queryParams = new URLSearchParams(window.location.search);
const encodedState = queryParams.get('state')|| getCookie('state');
const encodedError = queryParams.get('error');
const encodedCode = queryParams.get('code') || getCookie('code');
if (encodedError) {
  const auth0Domain = environment?.auth0?.domain;
  const clientId = environment?.auth0?.clientId;

  // Clear local and session storage before redirect
  localStorage.clear();
  sessionStorage.clear();
  deleteAllCookies();

  // Build the Auth0 logout URL
  const returnTo = window.location.origin + '/platform';
  const logoutUrl = `https://${auth0Domain}/v2/logout?client_id=${clientId}&returnTo=${encodeURIComponent(returnTo)}`;

  // Check error type and show appropriate alert
const errorMessages: Record<string, string> = {
    'access_denied': 'Access Denied',
    'invalid_request': 'Invalid Request'
};
alert(errorMessages[encodedError] || `Error: ${encodedError}`);

  // Redirect to Auth0 logout endpoint
  window.location.href = logoutUrl;
}
if (encodedState) {
  try {
    const decodedState = JSON.parse(atob(decodeURIComponent(encodedState)));
 
    setCookie('original_state', decodedState.original_state, 1);
    setCookie('tenant_code', decodedState.tenant_data.tenant_code, 1);
     if (encodedCode) {
        // debugger
      setCookie(`code`, encodedCode, 1);
    }
    
    if (encodedState) {
        // debugger
      setCookie(`state`, encodedState, 1);
    }
  } catch (e) {
 
  }
}
 
 
export const auth0Interceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<any> => {
  const accessToken = getCookie('access_token');
  const toaster = inject(ToastrService);
 
  const headers: Record<string, string> = {
    ...(accessToken && { 'Authorization': `Bearer ${accessToken}` })
  };
 
  const clonedRequest = req.clone({
    setHeaders: headers
  });

  if(!accessToken && !encodedState) {
    sessionTimeout();
  }
 
  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      const isUnauthorized = error.status === 401 || error.status === 403;
      const hasTokenInResponse = !!error.error?.access_token;
      if (isUnauthorized && !hasTokenInResponse) {
        toaster.error('Session expired. Please log in again.', 'Session Timeout');
        sessionTimeout();
      }
      return throwError(() => error);
    })
  );
};
